import { XStack, YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { Avatar } from '../internals/Avatar';
import { sizingClass, TEXT_STYLE } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

export const Person: ComponentFn<typeof catalog, 'Person'> = ({ props }) => (
  <XStack
    className={cn(
      'min-w-0 items-center gap-[var(--ac-gap-md)]',
      sizingClass(props.sizing)
    )}
  >
    <Avatar
      id={props.id}
      name={props.name}
      avatarUrl={props.avatar_url}
      shape="circle"
      size={28}
    />
    <YStack className="min-w-0">
      <span className="truncate text-[length:var(--ac-title)] font-medium leading-[var(--ac-title-lh)] text-foreground">
        {props.name}
      </span>
      {props.subtitle ? (
        <span className={cn('truncate text-foreground-muted', TEXT_STYLE.meta)}>
          {props.subtitle}
        </span>
      ) : null}
    </YStack>
  </XStack>
);
